import { BaseButton } from '@bnnvara/buttons';
import styled, { css, keyframes } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PointToDropdown = css`
  &::after {
    display: block;
    content: '';
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${({ theme }) => theme.base.white};
    position: absolute;
    z-index: 999;
    bottom: 0px;
  }
`;

export const IconButton = styled.button`
  position: relative;
  height: 74px;
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  background: transparent;
  border: 0;
  outline: none;
  overflow: visible;

  * > {
    border-radius: 50%;
  }
  ${({ isDropdownOpen }) => isDropdownOpen && PointToDropdown}
`;

const pop = keyframes`
  50%  {
    transform: scale(1.3);
  }
`;
export const NumberOfNotifications = styled.span`
  position: absolute;
  display: block;
  top: 20px;
  font-size: 10px;
  color: #fff;
  right: -6px;
  background: #0772e6;
  width: 16px;
  height: 12px;
  border-radius: 31px;
  line-height: 10px;
  font-family: ${({ theme }) => theme.fonts.primary};
  animation: ${pop} 0.3s linear 1;
`;

export const Icons = styled.div`
  display: flex;

  > * {
    margin-left: 1em;
  }

  :first-child {
    margin-left: 0;
  }
`;

export const LoginButton = styled(BaseButton)`
  margin: 8px;
`;

export const RegisterButton = styled.button`
  font-family: ${({ theme }) => theme.fonts.primary};
  border: none;
  background-color: white;
  color: ${({ theme }) => theme.primary.main};
  text-decoration: underline;

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.primary.light};
  }
`;
